import { Box, Button, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import { UserPlus } from "tabler-icons-react";
import ClientDasboardForm from "./projectDetailForm";
import { useUser } from "hooks/useUser";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useProject } from "api/projectDetail/getProjectDetail";

export default function ProjectDetail() {
  const [opened, setOpened] = useState(false);
  const { user } = useUser();
  const { projectId } = useParams<{ projectId: string }>();
  const queryClient = useQueryClient();

  const { data, isLoading, isError } = useProject(projectId!, user._id);
  if (!data) {
    return null;
  }
  if (isLoading) {
    return (
      <Box p="lg" style={{ backgroundColor: "#f5f5f5" }}>
        <Title order={2}>Loading...</Title>
      </Box>
    );
  }
  return (
    <Box p="lg" style={{ backgroundColor: "#f5f5f5" }}>
      <Group position="apart" mb="md">
        <Title order={2}>Project Details</Title>
      </Group>
      <Divider mb="md" />
      <ClientDasboardForm data={data} isLoading={isLoading} />
    </Box>
  );
}
